import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserDetails, UserRoles } from '../../models/user.model';
import { GlobalService } from '../../services/global.service';
import { MetabaseService } from '../../services/metabase.service';
import { MetabaseDashboardComponent } from '../metabase-dashboard/metabase-dashboard.component';
import { EMBEDDING_PARAMS, REPORT_IDS } from '../report.constants';

@Component({
    selector: 'fin-metabase-report',
    standalone: true,
    imports: [CommonModule, MetabaseDashboardComponent],
    templateUrl: './metabase-report.component.html',
    styleUrl: './metabase-report.component.scss'
})
export class MetabaseReportComponent implements OnInit, OnDestroy {
    jwtToken = '';
    initialParameters: Record<string, string | string[]> = {};
    embeddingParams: Record<string, unknown> = {};
    filterParams: Record<string, unknown> = {};
    reportId: number;
    userData: UserDetails;
    reportName = 'Dashboard';
    activeUserLevel = '';
    activeUserLevelRoles: UserRoles[] = [];
    private routeParamsSubscription?: Subscription;

    constructor(
        public metabaseService: MetabaseService,
        public route: ActivatedRoute,
        public globalService: GlobalService
    ) {}

    ngOnInit(): void {
        this.userData = this.globalService.getUserDetails();
        this.routeParamsSubscription = this.route.params.subscribe((params) => {
            this.reportId = +params['reportId'];
            this.reportName = params['reportName'];
            this.getInitialParameters();
            this.generateToken();
            this.reportVisibliltyLevel();
        });
    }

    ngOnDestroy(): void {
        this.routeParamsSubscription?.unsubscribe();
    }

    reportVisibliltyLevel() {
        this.activeUserLevel = this.userData.activeGeoLevel;
        this.activeUserLevelRoles = this.userData.roles;
    }

    generateToken() {
        this.embeddingParams = EMBEDDING_PARAMS.find((item) => item.name === this.reportId)?.params || {};

        this.metabaseService
            .generateToken(this.reportId, this.filterParams, this.embeddingParams)
            .subscribe((token) => {
                this.jwtToken = token;
            });
    }

    getInitialParameters(): void {
        switch (this.reportId) {
            case REPORT_IDS['PE']:
            case REPORT_IDS['PG']:
            case REPORT_IDS['CHC']:
            case REPORT_IDS['IFC']:
                this.initialParameters = { state: '', district: '' };
                break;
            default:
                this.initialParameters = {};
        }
    }
}
